import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import ReactDOM from "react-dom";
import {
  SnackStackContainer,
  SnackbarWrapper,
  Message,
  ActionButton,
} from "./index.styled";

const SnackContext = createContext(null);
export const useSnack = () => useContext(SnackContext);

const DISPLAY_MS = 3500;
const REMOVE_MS = 4000;

export const SnackbarProvider = ({ children }) => {
  const [snacks, setSnacks] = useState([]);

  const showSnack = useCallback(
    (
      msg,
      bg = "#1F1F1F",
      color = "#FFFFFF",
      actionText = null,
      onAction = null
    ) => {
      const key = crypto.randomUUID();

      setSnacks((prev) => [
        ...prev,
        {
          key,
          msg,
          bg,
          color,
          actionText,
          onAction,
        },
      ]);
    },
    []
  );

  const removeSnack = useCallback((key) => {
    setSnacks((prev) => prev.filter((s) => s.key !== key));
  }, []);

return (
  <SnackContext.Provider value={showSnack}>
    {children}
    <SnackBarStack snacks={snacks} onRemove={removeSnack} />
  </SnackContext.Provider>
);
};

function SnackBarStack({ snacks, onRemove }) {
  if (!snacks.length) return null;

  return ReactDOM.createPortal(
    <SnackStackContainer>
      {snacks.map((snack) => (
        <SnackBarItem
          key={snack.key}
          snack={snack}
          onRemove={onRemove}
        />
      ))}
    </SnackStackContainer>,
    document.body,
  );
}

function SnackBarItem({ snack, onRemove }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const exitTimer = setTimeout(
      () => setVisible(false),
      DISPLAY_MS,
    );

    const removeTimer = setTimeout(
      () => onRemove(snack.key),
      REMOVE_MS,
    );

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, [snack.key, onRemove]);

  return (
    <SnackbarWrapper
      $bg={snack.bg}
      $visible={visible}
      style={{ pointerEvents: "auto" }}
    >
      <Message $color={snack.color}>{snack.msg}</Message>

      {snack.actionText ? (
        <ActionButton
          onClick={() => {
            snack.onAction?.();
            setVisible(false);
            setTimeout(() => onRemove(snack.key), 500);
          }}
        >
          {snack.actionText}
        </ActionButton>
      ) : null}
    </SnackbarWrapper>
  );
}